module.exports = __webpack_public_path__ + "static/media/icon-money.f1537a37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-summary/icon-money.svg
// module id = 482
// module chunks = 0 1 2